<template>
  <form-filtered-multiselect
    :value="storedPreCarriage"
    :options="preCarriageRouteOptions"
    :placeholder="placeholder"
    :limit-height="limitHeight"
    :hide-selected="hideSelected"
    :disabled="disabled"
    track-by="value"
    label="label"
    @input="onPreCarriageSelected" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    limitHeight: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select PreCarriage'
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      storedPreCarriage: []
    }
  },
  computed: {
    ...mapGetters('preCarriageRoutes', ['preCarriageRouteOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedPreCarriage = newVal
    }
  },
  created () {
    this.storedPreCarriage = this.selectedKeys
  },
  methods: {
    onPreCarriageSelected (preCarriage) {
      this.$emit('valuesSelected', preCarriage)
    }
  }
}
</script>

<style>

</style>
